import type { BlockSlug } from '@codeware/shared/util/payload-types';

import { aboutGallery } from './about/AboutBlock.gallery';
import { calloutGallery } from './callout/CalloutBlock.gallery';
import { cardGallery } from './card/CardBlock.gallery';
import { codeGallery } from './code/CodeBlock.gallery';
import { contentGallery } from './content/ContentBlock.gallery';
import { customComponentGallery } from './custom-component/CustomComponentBlock.gallery';
import { featureCardsGallery } from './feature-cards/FeatureCardsBlock.gallery';
import { featureSectionGallery } from './feature-section/FeatureSectionBlock.gallery';
import { fileAreaGallery } from './file-area/FileAreaBlock.gallery';
import { formGallery } from './form/FormBlock.gallery';
import type { AnyBlockGalleryDoc } from './gallery-doc';
import { heroGallery } from './hero/HeroBlock.gallery';
import { imageGallery } from './image/ImageBlock.gallery';
import { pillListGallery } from './pill-list/PillListBlock.gallery';
import { postsGallery } from './posts/PostsBlock.gallery';
import { reusableContentGallery } from './reusable-content/ReusableContentBlock.gallery';
import { showcaseGallery } from './showcase/ShowcaseBlock.gallery';
import { socialMediaGallery } from './social-media/SocialMediaBlock.gallery';
import { spacingGallery } from './spacing/SpacingBlock.gallery';
import { testimonialGallery } from './testimonial/TestimonialBlock.gallery';
import { themeStudioGallery } from './theme-studio/ThemeStudioBlock.gallery';
import { toursGallery } from './tours/ToursBlock.gallery';

/**
 * What the gallery says about each block.
 *
 * `Partial` on purpose, and it is the one map here that is allowed to be
 * incomplete: a block with no entry is *undocumented*, which the gallery shows
 * as its own marked section rather than hiding. That is what stops the gallery
 * quietly falling behind — a block merged today appears the same day, unwritten
 * and visible, so the pressure to finish is public.
 *
 * The keys are still checked, so a typo cannot invent a block. What exists
 * comes from `BLOCK_META`, which is generated from the Payload registry.
 */
export const galleryDocs: Partial<Record<BlockSlug, AnyBlockGalleryDoc>> = {
  about: aboutGallery,
  callout: calloutGallery,
  card: cardGallery,
  code: codeGallery,
  content: contentGallery,
  'custom-component': customComponentGallery,
  'feature-cards': featureCardsGallery,
  'file-area': fileAreaGallery,
  form: formGallery,
  'feature-section': featureSectionGallery,
  hero: heroGallery,
  image: imageGallery,
  'pill-list': pillListGallery,
  posts: postsGallery,
  'reusable-content': reusableContentGallery,
  showcase: showcaseGallery,
  'social-media': socialMediaGallery,
  spacing: spacingGallery,
  testimonial: testimonialGallery,
  'theme-studio': themeStudioGallery,
  tours: toursGallery
};
